export default `
<!DOCTYPE html>
<html lang="ru">

<head>
  <meta charset="utf-8">
  <title>{{TITLE}}</title>
  <meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<style>
  .promo {
    display: block;
    margin: auto;
    text-align: center;
    max-width: 1280px;
  }
</style>

<body>
  <div class="promo">
    <img src="banner.{{EXTENSION}}" alt="{{TITLE}}">
    <div style="text-align:left; font-family:Arial,sans-serif;">
{{TEXTAREA}}
    </div>
  </div>
</body>

</html>
`;
